module.exports = __webpack_public_path__ + "img/driver-membership-tags.b8368377.png";